import { createFileRoute, redirect } from "@tanstack/react-router";

/** A former editor address an operator may have bookmarked mid-draft. The template id is the same;
 * only the path around it differs. */
export const Route = createFileRoute(
  "/_authenticated/_administration/admin/document-templates/$templateId/edit",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/settings/document-templates/$templateId",
      params: { templateId: params.templateId },
    });
  },
});
